export const addProductLocation = productLocations => {
  return [
    ...productLocations,
    {
      location_id: '',
      details: '',
    },
  ]
}

export const removeProductLocation = (productLocations, index) => {
  return productLocations.filter((_, i) => i !== index)
}

export const updateProductLocation = (productLocations, index, field, value) => {
  return productLocations.map((productLocation, i) => {
    if (i === index) {
      return {
        ...productLocation,
        [field]: value,
      }
    }
    return productLocation
  })
}

export const getLocationError = productLocation => {
  if (productLocation?.details && !productLocation?.location_id) {
    return 'Este campo es requerido'
  }

  return null
}
